import { APIResourceService } from '@/core/services/APIService'
import Task from '@/core/resources/Task'
import { buildException } from '@/core/exceptions'

export class TaskService extends APIResourceService<Task> {
  constructor() {
    super(Task)
  }

  /**
   * Appel API pour redémarrer une liste de tâches
   * @param tasks_id Identifiants des tâches à redémarrer
   * @param token Jeton de session JWT
   * @return Vrai si les tâches ont été redémarrées sinon on lève une exception
   * @throws PolluxApiError si la suppresion a échoué
   */
  restart(tasks: Array<Task>, token: string): Promise<boolean> {
    const json = {
      ids: tasks.map((task) => task.id)
    }
    return this.client
      .post('/tasks/restart_list', json, token)
      .then(() => true)
      .catch((err) => {
        throw buildException(err)
      })
  }
}
